module.exports = __webpack_public_path__ + "static/media/dmiLogo1.2f75c33f.svg";